import { render } from "./CopyTokenModal.vue?vue&type=template&id=4a99a549&scoped=true"
import script from "./CopyTokenModal.vue?vue&type=script&lang=js"
export * from "./CopyTokenModal.vue?vue&type=script&lang=js"

import "./CopyTokenModal.vue?vue&type=style&index=0&id=4a99a549&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a99a549"]])

export default __exports__